<section>
    <h2 class="header">{{pageData.header}}</h2>
    <div class="notification-banner" *ngIf="enableICOPPhaseOneSegSwitch && promotionsBanner">
        <xm-media-image [imageOptions]="infoIconGrey" size="width" center="vert" class="icon"></xm-media-image>
        <div class="contents">
            <div class="notification-content">
                <h2 class="promotions-header">{{promotionsBanner?.header}}</h2>
            </div>
            <div class="content">
                <ul class="custom-bullet-list" *ngFor="let promo of promotionsBanner?.promotionContent?.promos">
                    <li>{{ promo.text }}
                        <a class="underlined-cta" *ngIf="promo.modal?.ctaContent" (click)="openPromoModal()">
                            {{ promo.modal.ctaContent }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="notification-banner" *ngIf="(enableICOPPhaseOneSegSwitch && !promotionsBanner && !isBusinessUser)">
        <xm-media-image [imageOptions]="infoIconGrey" size="width" center="vert" class="icon"></xm-media-image>
        <div class="contents">
            <div class="notification-content">
                <cms-text class="promotions-header" [originalText]="isBuyFLowConvergenceEnabled && pageData.promoBannerContentBuyFlowUrl ? pageData.promoBannerContentBuyFlowUrl : pageData.promoBannerContent"></cms-text>
            </div>
        </div>
    </div>
    <form [formGroup]="planTypeform">
        <div formArrayName="dropdowns">
            <div class="line-card-container">
                <div class="card" *ngFor="let line of lines; let i = index">
                    <div class="name-icon" [style.backgroundColor]="line.color"><span>{{ line.iconLetter }}</span></div>
                    <div class="display-name">
                        <p [id]="line.id.value" class="name">{{ line.displayName }}</p>
                        <p class="line-status" *ngIf="line.isActive && line.isDevice">{{ line.lineNumber | phone }}</p>
                        <p class="line-status" *ngIf="line.isActive && line.isWatch && line.pairedLineNumber">Paired
                            with {{
                            line.pairedLineNumber | phone }}</p>
                        <p class="line-status" *ngIf="line.isActive && line.planName">{{ line.planName }}</p>
                    </div>
                    <p *ngIf="!line.isWatch" role="region" [attr.aria-labelledby]="line.id.value"
                        class="line-data-usage">{{
                        line.lineDataUsage }} GB</p>
                    <div class="card-footer">
                        <p *ngIf="line.promotionContent">{{line.promotionContent}}</p>
                        <ng-container *ngIf="line.isTablet || line.isWatch">
                            <p *ngIf="line.isTablet && !line.dataOptions?.isEditable">{{pageData.noSelectionTabletContent}}</p>
                            <p *ngIf="line.isWatch && !line.dataOptions">{{pageData.noSelectionWatchContent}}</p>
                        </ng-container>
                        <xm-validation *ngIf="line.dataOptions"
                            [formCtrl]="dropdowns.controls[i]" [options]="planTypeOptions">
                            <xm-dropdown formControlName="{{i}}" [ariaLabelId]="'plan-type-id'"
                                [placeholder]="pageData.dropDownPlaceHolder" [scrollHeight]="'300px'"
                                [optionsList]="line.dataOptions.options" [isDisabled]="!line.dataOptions.isEditable"
                                (onCollapse)="onDropDownSelection($event)">
                            </xm-dropdown>
                        </xm-validation>
                    </div>
                </div>
            </div>
        </div>
    </form>
</section>
